import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';
import { groupForgotPasswordActions, groupVisitActions, groupVisitPasswordActions, groupVisitsActions } from './groupVisits.actions';
import { GroupVisitDto, groupVisitInit } from './groupVisits.dtos';

const groupVisitReducer = combineReducers({
    list: createReducer<GroupVisitDto[]>([] as GroupVisitDto[])
      .handleAction(
        [
          groupVisitsActions.success,
        ], (state, action) => action.payload),
  
    groupVisit: createReducer<GroupVisitDto>(groupVisitInit)
      .handleAction(
        [
          groupVisitActions.success,
        ], (state, action) => action.payload),

    passwordResetRequired: createReducer<boolean>(false)
      .handleAction(
        [
          groupVisitPasswordActions.success,
        ], (state, action) => action.payload
      ),
  });
  
  
  export default groupVisitReducer;